import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-view-cart', (editor, opts) => {
  const config = {
    blocks: [
      'viewCartInfo',
    ],
    name: 'viewCartInfo',
    stylePrefix: 'gjs-',
    defText: 'Sample',
    category: 'Pagos',
    labelComponent: 'Visualizar Compra',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
